/**
 * @generated SignedSource<<370af5aec90a6cfa9577a0edb5470b59>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraUrlField_Platform$data = {
  readonly fieldConfig: {
    readonly isEditable: boolean | null;
    readonly isRequired: boolean | null;
  } | null;
  readonly name: string;
  readonly uri: string | null;
  readonly " $fragmentType": "JiraUrlField_Platform";
};
export type JiraUrlField_Platform$key = {
  readonly " $data"?: JiraUrlField_Platform$data;
  readonly " $fragmentSpreads": FragmentRefs<"JiraUrlField_Platform">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "JiraUrlField_Platform",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "concreteType": "JiraFieldConfig",
      "kind": "LinkedField",
      "name": "fieldConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isEditable"
        },
        {
          "kind": "ScalarField",
          "name": "isRequired"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "uri"
    }
  ],
  "type": "JiraUrlField"
};

(node as any).hash = "fe0925cf185b84cb8f1f85633532636e";

export default node;
